// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Et9K","list":"styles_list__3yS9k"};